import { ResourceOptions } from 'react-admin';
import { Resources } from '../../resource';

export { default as list } from './List';
export const name = Resources.whitelistUsers;
export const options: ResourceOptions = {
  label: 'whitelist.users.title',
};
